import { useEffect } from "react";
import { useIntersectionObserver } from "usehooks-ts";

export interface UseFeedInfiniteScrollProps {
  fetchPage: () => Promise<unknown> | void;
  canFetchMore: boolean;
}

export default function useFeedInfiniteScroll({
  fetchPage,
  canFetchMore,
}: UseFeedInfiniteScrollProps): (node?: Element | null) => void {
  const { isIntersecting, ref: infiniteScrollRef } = useIntersectionObserver({
    threshold: 0.1,
    rootMargin: "75px",
  });

  useEffect(() => {
    if (isIntersecting && canFetchMore) {
      fetchPage();
    }
    // @NOTE see https://dailydotdev.atlassian.net/l/cp/dK9h1zoM
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isIntersecting, canFetchMore]);

  return infiniteScrollRef;
}
